// extracted by mini-css-extract-plugin
module.exports = {"indicator_value":"hAk4QeJ","input_parent":"NuPXjoX"};